import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { PaymentReceipt } from "./PaymentReceipt";

// Shared popup that renders a payment receipt with Save & Share actions.
// Used by the Customer portal, Subscription Profile and Customer Profile.
export function ReceiptDialog({ open, onOpenChange, data }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="receipt-dialog">
        <DialogHeader>
          <DialogTitle>Payment Receipt</DialogTitle>
        </DialogHeader>
        {data && <PaymentReceipt data={data} />}
      </DialogContent>
    </Dialog>
  );
}
